export default __webpack_public_path__ + "d422bac5afe95d8bf9a059c7e50b79ad.jpg";